import React from 'react'
import Skeleton from "react-loading-skeleton";

const FacilitiesListSkeleton = () => {
  return (
   <div className="row kiosk-row">
      {Array.apply(0, Array(12)).map((n, i) => (
        <div className="col-6" key={i} style={{marginBottom: "19px", lineHeight: 1}}>
          <Skeleton height={94}/>
        </div>
      ))}
    </div>
  )
}

export default FacilitiesListSkeleton
